var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ykz-dialog', {
    attrs: {
      "value": _vm.value,
      "width": "630px",
      "closeOnClickModal": false,
      "showClose": "",
      "closeIconPosition": "rightTop",
      "lock": "",
      "borderRadius": "12px"
    },
    on: {
      "close": function close($event) {
        return _vm.$emit('input', false);
      }
    }
  }, [_c('div', {
    staticClass: "video-sale"
  }, [_c('div', {
    staticClass: "video-title"
  }, [_vm._v("视频号带货")]), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "statement"
  }, [_c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "txt"
  }, [_vm._v("下载商品视频或者自己创作短视频")])]), _c('div', {
    staticClass: "statement"
  }, [_c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "txt"
  }, [_vm._v("在下方获取自己专属的视频号扩展链接（每天仅可生成5次）")])]), _c('div', {
    staticClass: "statement"
  }, [_c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "txt"
  }, [_vm._v("在微信视频号上发布短视频时，填入获取的专属扩展链接，完成发布")])])]), _c('div', {
    staticClass: "btn"
  }, [_c('ykz-button', {
    attrs: {
      "type": "primary",
      "width": "418px",
      "height": "80px",
      "round": "",
      "disabled": _vm.generated
    },
    on: {
      "click": _vm.handleGenerate
    }
  }, [_vm._v("生成专属扩展链接")])], 1), _vm.generated ? _c('div', {
    staticClass: "link-copy"
  }, [_c('div', {
    staticClass: "link-txt"
  }, [_vm._v(_vm._s(_vm.articleUrl))]), _c('ykz-button', {
    attrs: {
      "type": "primary",
      "width": "418px",
      "height": "80px",
      "round": ""
    },
    on: {
      "click": _vm.handleCopyLink
    }
  }, [_vm._v("复制扩展链接")])], 1) : _vm._e()])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };